module.exports = __webpack_public_path__ + "img/10.51da41ac.jpg";